var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{attrs:{"id":"create-llm","title":`Create a new Large Language Model`,"show":true},on:{"close":_vm.close}},[_c('newLLM',{attrs:{"isCreate":true},on:{"createLLM":_vm.create}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }